function isNullOrEmpty(val) {
	if (val === null) {
		return true;
	} else if (val === '') {
		// return true;
		return false;
	} else if (Array.isArray(val) && val.length <= 0) {
		return true;
	} else {
		return false;
	}
}

function stringify(param) {
	if (!param) {
		return "";
	}
	var paramStr = "";
	for (var k in param) {
		var v = param[k];
		if (!isNullOrEmpty(v)) {
			paramStr += "&" + k + "=";
			if (Array.isArray(v)) {
				paramStr += encodeURIComponent(v.join(','));
			} else if (typeof v != 'object') {
				paramStr += encodeURIComponent(v);
			}
		}
	}
	return paramStr.substr(1);
}

function GetQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
	var context = "";
	if (r != null)
		context = r[2];
	reg = null;
	r = null;
	return context == null || context == "" || context == "undefined" ? "" : context;
}

function getCookies(name) {
	var cookies = document.cookie.split(";");
	for (var i = 0; i < cookies.length; ++i) {
		var a = cookies[i].split("=");
		if (a.length == 2) {
			a[0] = a[0].trim();
			a[1] = a[1].trim();
			if (a[0] == name) {
				return unescape(a[1]);
			}
		}
	}
	return null;
}

var deleteIsShow = true;

function setDeleteIsShow(val) {
	deleteIsShow = val;
}

function getDeleteIsShow() {
	return deleteIsShow;
}

var addIsShow = true;

function setAddIsShow(val) {
	addIsShow = val;
}

function getAddIsShow() {
	return addIsShow;
}

export default {
	isNullOrEmpty: isNullOrEmpty,
	stringify: stringify,
	GetQueryString:GetQueryString,
	getCookies:getCookies,
	setDeleteIsShow:setDeleteIsShow,
	getDeleteIsShow:getDeleteIsShow,
	setAddIsShow:setAddIsShow,
	getAddIsShow:getAddIsShow
}
